import { FormattedMessage } from 'react-intl'
import Info from 'components/shared/Info'
import Link from 'components/shared/Link'
import Text from 'components/shared/Text'
import Box from 'components/shared/Box'
import { TIMETABLE_ZYRARDOW_LINK } from 'constants/links'

const ShuttleInfo = () => (
    <Box mt={16}>
        <Info
            color="info_warning"
            align={['flex-start', 'center']}
            hasBorder
            hasNoBackground
        >
            <>
                <FormattedMessage
                    id="upsells.bus.zyrardow_suntago_shuttle_info"
                    defaultMessage="Bilet na tę trasę uprawnia do jednego przejazdu o dowolnej godzinie. "
                />
                <Link
                    variant="secondary"
                    icon={null}
                    path={TIMETABLE_ZYRARDOW_LINK}
                    target="_blank"
                    data-testid="transport-redirect-timetable"
                >
                    <Text variant="bodySmallStrong">
                        <FormattedMessage
                            id="upsells.bus.schedule_link"
                            defaultMessage="Sprawdź rozkład"
                        />
                    </Text>
                </Link>
            </>
        </Info>
    </Box>
)

export default ShuttleInfo
